import { checkIsExtension } from "../../helpers/helpers";
import { baseFetchExtensionSimple } from "../baseFetchExtension";
import { baseFetchWebSimple } from "../baseFetchWeb";
export class PacvueUnauthorizedError {
    constructor(response) {
        this.response = response;
    }
}
export async function baseFetchSimple(request) {
    const response = checkIsExtension()
        ? await baseFetchExtensionSimple(request)
        : await baseFetchWebSimple(request);
    return await validateResponse(response, request);
}
const validateResponse = async (response, request) => {
    if (response.status === 401 && response.error?.origin === "pacvue" && !request.ignore401) {
        throw new PacvueUnauthorizedError(response);
    }
    return response;
};
